@use "@fukuri-admins/ui/layout" as *;

.content {
  display: flex;
  flex-direction: column;
  gap: spacing('24');
  padding: spacing('24');

  &__title {
    @include typography('Jp/20_W6');
    color: text('High');
  }
}

.form {
  width: 564px;
}

.selectOption {
  display: flex;
  @include typography('Jp/14_W3');

  &__name {
    color: text('High');
  }

  &__code {
    color: text('Low');
  }
}
